import { render, staticRenderFns } from "./createtemplate.vue?vue&type=template&id=8b5c7b9c&scoped=true&"
import script from "./createtemplate.vue?vue&type=script&lang=js&"
export * from "./createtemplate.vue?vue&type=script&lang=js&"
import style0 from "./createtemplate.vue?vue&type=style&index=0&id=8b5c7b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5c7b9c",
  null
  
)

export default component.exports